/**
 * Route for `affiliate-signup`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateSignupPage } from "../features/affiliate-signup/AffiliateSignupPage";

export const affiliateSignupRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-signup",
	component: AffiliateSignupPage,
});

export default affiliateSignupRoute;
